import { Company, ICompanyRepository } from "../domain/Company"


export class LoadCompanyScreen {
    company_repo: ICompanyRepository
    screen_data: ILoadCompanyScreenData

    constructor(
        company_repo: ICompanyRepository,
        screen_data: ILoadCompanyScreenData
    ) {
        this.company_repo = company_repo
        this.screen_data = screen_data
    }

    async getCompany(user_id:number, code:string, cdb_type:string) {
        const company = await this.company_repo.find_by_type_and_code(user_id, code, cdb_type)
        this.screen_data.setLoading(false)

        if (company) {
            this.screen_data.setCompany(company)
            this.screen_data.setFound(true)
        } else {
            this.screen_data.setNotFound(true);
        }

    }

}

export interface ILoadCompanyScreenData {
    company: Company|null
    loading: boolean
    show_found_popup: boolean
    show_not_found_popup: boolean

    setCompany(company:Company): void;
    setLoading(value:boolean): void;
    setFound(value:boolean): void;
    setNotFound(value:boolean): void;
}